<div>
	<p-table
		#mydt
		[value]="lstVisitorPassDetail"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedVisitorPassDetail"
		dataKey="VisitorPassDetailID"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--VisitorPassDetailStatusDesc-->
				<th>
					<p-columnFilter field="VisitorPassDetailStatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterVisitorPassDetailStatusDesc
								[ngModel]="value"
								[options]="lstVisitorPassDetailStatusDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Location-->
				<th>
					<p-columnFilter type="text" field="Location" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ScanStation-->
				<th>
					<p-columnFilter field="ScanStation" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterScanStation
								[ngModel]="value"
								[options]="lstScanStation"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Facility-->
				<th>
					<p-columnFilter field="Facility" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterFacility
								[ngModel]="value"
								[options]="lstFacility"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--LogDT-->
				<th>
					<p-columnFilter type="text" field="LogDT" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="VisitorPassDetailStatusDesc">Status<p-sortIcon field="VisitorPassDetailStatusDesc"></p-sortIcon></th>
				<th pSortableColumn="Location">Location<p-sortIcon field="Location"></p-sortIcon></th>
				<th pSortableColumn="ScanStation">ScanStation<p-sortIcon field="ScanStation"></p-sortIcon></th>
				<th pSortableColumn="Facility">Facility<p-sortIcon field="Facility"></p-sortIcon></th>
				<th pSortableColumn="LogDT">Date<p-sortIcon field="LogDT"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-VisitorPassDetail>
			<tr [pSelectableRow]="VisitorPassDetail">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ VisitorPassDetail.VisitorPassDetailStatusDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ VisitorPassDetail.Location }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ VisitorPassDetail.ScanStation }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ VisitorPassDetail.Facility }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ VisitorPassDetail.LogDTDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
